import { useMutation, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_AI_SUMMARY, TRIGGER_AI_PROCESSOR } from '../graphql/queries/aiSummary';
/**
 * Hook that fetches AI responses based on the provided spec and provides
 * functionality to trigger the AI processor for running a new AI job.
 * Note the triggerAiProcessor function is async and returns a boolean indicating
 * whether the AI processor was triggered successfully.
 */
export const useAiSummary = (spec) => {
    const documentEntityId = spec.documentEntityId ? parseInt(spec.documentEntityId) : undefined;
    const { data, loading, error, refetch } = useQuery(GET_AI_SUMMARY, {
        variables: {
            spec: {
                ...spec,
                documentEntityId,
            },
        },
    });
    const aiSummaryResponse = data;
    const aiSummaryResponseItems = useMemo(() => aiSummaryResponse ? aiSummaryResponse?.getAiSummary?.items : [], [aiSummaryResponse]);
    const [triggerAiProcessorMutation] = useMutation(TRIGGER_AI_PROCESSOR);
    const triggerAiProcessor = async (input) => {
        try {
            const result = await triggerAiProcessorMutation({
                variables: {
                    input: {
                        ...input,
                    },
                },
            });
            return result.data?.triggerAiProcessor ?? false;
        }
        catch (error) {
            return false;
        }
    };
    return {
        aiSummaryResponse,
        aiSummaryResponseItems,
        loading,
        error,
        refetch,
        triggerAiProcessor,
    };
};
